/*************************************************/
/* PersonTabs */
/*************************************************/

export function personTab() {
    const containerSelector = '.person-tabs-container';
    const tabSelector = '.tab';
    const activeClass = 'active';

    const init = () => {
        const containers = document.querySelectorAll(containerSelector);

        containers.forEach(container => {
            const tabs = container.querySelectorAll(tabSelector);

            tabs.forEach(tab => {
                tab.addEventListener('click', () => {
                    // Remove 'active' from all tabs inside the same container
                    tabs.forEach(t => t.classList.remove(activeClass));
                    // Add 'active' to the clicked tab
                    tab.classList.add(activeClass);
                });
            });
        });
    };

    init();
}

personTab();